import React, { Component } from 'react';
import './assign-section.scss';
import 'bootstrap-daterangepicker/daterangepicker.css';
import PaginationComponent from '../../common/cw-pagination/cw-pagination-v2'
import Loading from '../../common/loading/loading'
import SessionCache from '../../routes/session-cache';
import SchoolUserApi from '../../../apis/student'
import { ImageConstants, AccessRights } from '../../../constants/constants';
import { getImageSource } from '../../../utility/image-source';
import PillButtonSelect from '../../common/pill-button-select/pill-button-select';
import SchoolApi from '../../../apis/school'
import SelectSection from './select-section/select-section'
import { Link } from 'react-router-dom'
import Path from '../../routes/routes-path';
import ToasterComponent from '../../common/cw-toaster-component/cw-toaster-component';


class AssignSection extends Component {

    state = {
        isLoading: true,
        meta: {},
        tabs: [],
        boards: []
    }
    filter = {}
    selectedUserHash = {}
    classHash = {}

    constructor(props) {
        super(props)
        this.user = SessionCache.getUser()
    }

    componentDidMount() {
        this.getClasses()
    }

    getClasses(payload = {}) {
        SchoolApi.getClassAndBoard(payload)
            .then(school => {
                let classes = [], boards = [];
                let selectedClass = this.props.selectedClass;
                for (let i = 0; i < school.classes.length; i++) {
                    classes.push({
                        title: school.classes[i].name,
                        value: school.classes[i].name,
                    })
                }
                if (!selectedClass) selectedClass = classes[0].title
                for (let i = 0; i < school.boards.length; i++) {
                    boards.push({
                        title: school.boards[i].name,
                        value: school.boards[i].name,
                    })
                }
                let selectedBoard = boards[0].title
                this.setState({ tabs: classes, boards, selectedBoard, selectedClass }, _ => {
                    if (this.boardPillButtonRef) this.boardPillButtonRef.onSelect(boards[0])
                    const filteredClass = classes.filter(c => c.title === selectedClass)
                    if (this.classPillButtonRef) this.classPillButtonRef.onSelect(filteredClass[0])
                })
            }).catch(err => {
            })
    }

    getStudent(payload = {}, checkBack) {

        if (!payload) payload = this.filter || {}
        if (!payload.class) payload.class = this.state.selectedClass
        if (!payload.board) payload.board = this.state.selectedBoard

        payload.type = "WITHOUT_SECTION"

        payload.page = this.filter.page || 1
        payload.limit = 10

        this.currentPage = payload.page


        this.setState({ isLoading: true })
        SchoolUserApi.getSchoolUsers(payload)
            .then(response => {

                if (checkBack && this.state.selectedClass == "ALL" && !response?.response?.length) {
                    this.props.back()
                    return
                }

                this.setState({
                    studentList: response.response,
                    meta: response.meta || {},
                    isLoading: false,
                    showList: false
                }, () => {
                    this.setState({ showList: true })
                })
            }).catch(err => {
                this.setState({ studentList: [], isLoading: false })
            })
    }

    onPageSelected = (selectedPage, startIndex) => {
        this.startIndex = startIndex
        this.filter.page = selectedPage
        this.setState({ selectedPage })
        this.getStudent()
    }

    onClickAssign() {
        this.setState({ showSelectSection: true })
    }

    selectAllUser() {
        if (this.state.selectedUsers?.length == this.state.studentList?.length) {
            this.selectedUserHash = {}
            this.classHash = {}
            this.setState({ selectedUsers: [], })
        } else {
            let selectedUsers = this.state.studentList?.map(item => {
                this.selectedUserHash[item._id] = true
                this.classHash[item.class] = this.classHash[item.class] ? this.classHash[item.class] + 1 : 1
                return item
            })
            this.setState({ selectedUsers })

        }
    }

    onCLickUser(user) {
        if (this.selectedUserHash[user._id]) {
            this.selectedUserHash[user._id] = false
            this.classHash[user.class] -= 1
            let selectedUsers = this.state.selectedUsers || []
            selectedUsers = selectedUsers.filter(item => item._id != user._id)
            this.setState({ selectedUsers })
        } else {
            this.selectedUserHash[user._id] = true
            let selectedUsers = this.state.selectedUsers || []
            this.classHash[user.class] = this.classHash[user.class] ? this.classHash[user.class] + 1 : 1
            selectedUsers.push(user)
            this.setState({ selectedUsers })
        }
    }

    onSelectPillButton = (value, key) => {
        this.setState({ [key]: value }, _ => {
            this.getStudent()
        })
    }

    closeSelectSection = () => {
        this.setState({ showSelectSection: false })
    }

    getClassNames() {
        if (this.state.selectedClass == "ALL") {
            let classes = []
            for (let key in this.classHash) {
                let classDetail = this.classHash[key]
                if (classDetail > 0) {
                    classes.push(key)
                }
            }
            return classes
        } else {
            return [this.state.selectedClass]
        }
    }

    onSaveSection = (section) => {
        let message = `${this.state.selectedUsers?.length || 0} students assigned a section ${section}`
        this.showToaster("info", message)
        this.setState({ showSelectSection: false, selectedUsers: [] })
        this.getStudent({}, true)
    }

    showToaster(type, message) {
        this.setState({
            showToaster: true,
            toasterMessage: message,
            toasterType: type
        }, () => {
            setTimeout(() => { this.hideToaster() }, 3000);
        });
    }

    hideToaster() {
        this.setState({
            showToaster: false
        });
    }


    render() {

        return (
            <>
                {
                    this.state.isLoading && <div ><Loading /> </div>
                }


                <div className='assign-section'>

                    <div className='header-container'>
                        <span className='screen-title'>
                            {this.props.from === "students" ?
                                <div onClick={this.props.back}>
                                    <img className="back-icon cursor-pointer" src={getImageSource(ImageConstants.BACK_ICON)} />
                                </div> :
                                <Link to={Path.CLASSES}>
                                    <img className="back-icon cursor-pointer" src={getImageSource(ImageConstants.BACK_ICON)} />
                                </Link>
                            }
                        </span>
                        {
                            this.state.selectedUsers?.length ?
                                <span className='float-right custom-btn' onClick={() => this.onClickAssign()}>
                                    ASSIGN SECTION TO SELECTED STUDENTS
                                </span>
                                : ""
                        }
                    </div>

                    <div className="mt-4">
                        <div className="screen-title">
                            Assign Section
                        </div>
                        {this.state.boards?.length > 1 &&
                            <div className="row class-filter my-4 mx-2">
                                <div className="col my-auto">
                                    <PillButtonSelect
                                        ref={el => this.boardPillButtonRef = el}
                                        className="custom-pill"
                                        onSelect={(value) => this.onSelectPillButton(value, "selectedBoard")}
                                        options={this.state.boards}
                                        value={this.state.selectedBoard}
                                        width="150px"
                                    />
                                </div>
                            </div>
                        }
                        <div className="row class-filter my-4 mx-2">
                            <div className="col my-auto">
                                <PillButtonSelect
                                    ref={el => this.classPillButtonRef = el}
                                    className="custom-pill"
                                    onSelect={(value) => this.onSelectPillButton(value, "selectedClass")}
                                    options={this.state.tabs}
                                    value={this.state.selectedClass}
                                    width="150px"
                                />
                            </div>
                        </div>

                    </div>


                    <div className="pt-4">
                        <div id="table-scoll" className="table-responsive">
                            <table className="table cw-table">
                                <thead>
                                    <tr>
                                        <th className='th-left-radius th-width cursor-pointer' onClick={this.selectAllUser.bind(this)}><img className="tick" src={getImageSource(this.state.selectedUsers?.length > 0 && this.state.selectedUsers?.length == this.state.studentList?.length ? ImageConstants.RECT_TICK : ImageConstants.RECT)} /></th>
                                        <th>Student</th>
                                        <th className='th-right-radius'>Class</th>
                                    </tr>
                                </thead>
                                <tbody className="bg-white">
                                    {
                                        this.state.studentList && this.state.studentList.length ? this.state.studentList.map((item, index) => (

                                            <tr key={item._id} className="cursor-pointer" onClick={() => this.onCLickUser(item)}>
                                                <td><img className="tick" src={getImageSource(this.selectedUserHash[item._id] ? ImageConstants.RECT_TICK : ImageConstants.RECT_BLACK)} /> </td>
                                                <td className="name">{item.name}</td>
                                                <td>{item.class}</td>
                                            </tr>
                                        ))
                                            : <tr className="bg-white pt-4"><td colSpan="3" align='center'>No Records found</td></tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                        <div className='card-footer'>
                            {
                                this.state.meta?.totalPages ?
                                    <PaginationComponent startIndex={this.startIndex} selectedPage={this.currentPage} totalPages={this.state.meta?.totalPages} onPageSelected={this.onPageSelected.bind(this)} /> : ''
                            }
                        </div>
                    </div>
                    {
                        this.state.showSelectSection ? <SelectSection users={this.state.selectedUsers} selectedClass={this.getClassNames()} selectedBoard={this.state.selectedBoard} onClose={this.closeSelectSection} onSave={this.onSaveSection} /> : ""
                    }
                    {this.state.showToaster ? <div className='custom-toaster-modal'> <ToasterComponent message={this.state.toasterMessage} type={this.state.toasterType} position="bottom-center" /></div>
                        : ""}
                </div >
            </>);
    }
}

export default AssignSection;